class CartRemoveButton extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();
    this.costoEnvioDomicilio = window.costoEnvioDomicilio;
    this.carrito = null;
    this.estadoTrabajoPagina = localStorage.getItem('ph-metodo-entrega') || 'local';
  }

  connectedCallback() {
    this.etiquetaEnvioADomicilio = this.querySelector('#phpc-etiqueta-enviodominicilio');

    this.btnPagar = this.querySelector('#phpc-btn-pagar');
    this.contenedorItemsDetalle = this.querySelector('.pcph-items-carrito');
    this.carritoVacioContenedor = this.querySelector('.pcph-carrito-vacio');
    this.contenedorDerecho = this.querySelector('.pcph-carrito-derecho');
    this.etiquetaSubtotal = this.querySelector('#phpc-etiqueta-subTotal');
    this.etiquetaDescuento = this.querySelector('#phpc-etiqueta-descuento');
    this.etiquetaTotal = this.querySelector('#phpc-etiqueta-total');

    this.btnPagar.addEventListener('click', () => this.pagarBtnPrincipal());
    this.inicializarDataShopify();
  }

  async inicializarDataShopify() {
    try {
      // Mostrar mensaje de carga al iniciar
      MensajeCargaDatos.mostrar('Cargando información del carrito...');

      this.carrito = (await AuxiliaresGlobal.obtenerCarritoShopify()).informacionCompleta;
      console.log('🔍 this.carrito:', this.carrito);

      let contenidoIzquierdoHTML = '';
      let precioTotal = 0;
      let precioTotalComparacion = 0;

      // Si el carrito esta vacio
      if (this.carrito.items.length == 0) {
        this.carritoVacioContenedor.style.display = 'flex';
        this.contenedorItemsDetalle.style.display = 'none';
      } else {
        this.carritoVacioContenedor.style.display = 'none';
        this.contenedorItemsDetalle.style.display = 'flex';

        this.carrito.items.forEach((item) => {

          if (!(item.properties && item.properties.estructura)) {
            return;
          }

          const dataContruccion = JSON.parse(item.properties.estructura);

          // Calcular precio individual de este item (no acumulativo)
          let precioTotalItem = dataContruccion.item_base.precio * dataContruccion.item_base.cantidad;
          let precioTotalComparacionItem = dataContruccion.item_base.precio_comparacion == 0
            ? dataContruccion.item_base.precio * dataContruccion.item_base.cantidad
            : dataContruccion.item_base.precio_comparacion * dataContruccion.item_base.cantidad;

          dataContruccion.items_principales.productos.forEach((producto) => {
            precioTotalItem += producto.precio * producto.cantidad;
            precioTotalComparacionItem += producto.precio_comparacion == 0 ? producto.precio * producto.cantidad : producto.precio_comparacion * producto.cantidad;
          });

          precioTotal += precioTotalItem;
          precioTotalComparacion += precioTotalComparacionItem;

          contenidoIzquierdoHTML += `
          <div data-kitem="${item.key}" class="pcph-item-carrito">
            <div class="pcph-itemc-detalle">
              <div class="pcph-itemc-imagen">
              ${precioTotalComparacionItem > precioTotalItem ? `
                <div class="pcph-itemc-etiqueta-precio-comparacion">
                  <p>${GestorProductos.calcularDescuento(
            precioTotalItem,
            precioTotalComparacionItem
          )}</p>
                </div>
                ` : ''
            }
                <img src="${dataContruccion.item_base.imagen}" alt="${dataContruccion.item_base.nombre}" width="100" height="100">
              </div>
              <div class="pcph-itemc-info">
                <div class="pcph-itemc_opcion1">
                  <div class="pcph-itemc_bloque-izq">
                  <div class="pcph-itemc-detalles-primarios">
                    <h1>${dataContruccion.item_base.nombre}</h1>
                    ${dataContruccion.items_principales.productos.length > 0
              ? `<p>${dataContruccion.items_principales.titulo}</p>
                          <ul class="color-letras-extra">`
              : ''
            }
          `;

          let tituloGuardado = "";
          let contenidoGenerado = "";

          dataContruccion.items_principales.productos.forEach((producto, index) => {
            // Preparamos el título del producto, quitando la palabra "Extra" si está presente
            let tituloProducto = producto.nombre;
            if (tituloProducto.includes("Extra")) {
              tituloProducto = tituloProducto.replace("Extra ", "");
            }

            // Si es el primer producto o si cambia el título de sección
            if (index === 0 || tituloGuardado !== producto.titulo) {
              // Si no es el primer producto, cerramos el item anterior
              if (index > 0) {
                contenidoIzquierdoHTML += contenidoGenerado + "</p></li>";
              }

              // Actualizamos el título guardado
              tituloGuardado = producto.titulo;

              // Iniciamos un nuevo ítem con el título de sección
              contenidoGenerado = `<li><p>${producto.titulo} : <br> ${tituloProducto}`;
            } else {
              // Si es el mismo título de sección, solo agregamos el producto
              contenidoGenerado += `<br> ${tituloProducto}`;
            }
          });

          // No olvidar cerrar el último ítem
          if (dataContruccion.items_principales.productos.length > 0) {
            contenidoIzquierdoHTML += contenidoGenerado + "</p></li>";
          }

          contenidoIzquierdoHTML += `
                    </ul>
                  </div>
                  <div class="pcph-itemc-precio-comparacion pcph-itemc-precio-inline">
                    <h2 class="color-letras-primary">Bs. ${(precioTotalItem / dataContruccion.item_base.cantidad).toFixed(2)} </h2>
                    ${precioTotalComparacionItem > precioTotalItem ? `
                      <h4 class="color-letras-precioCS">Bs. ${(precioTotalComparacionItem / dataContruccion.item_base.cantidad).toFixed(2)}</h4>
                    ` : ''}
                  </div>
                  </div>
                  <div class="pcph-itemc-precio-comparacion pcph-itemc-precio-cantidad">
                    <h2 class="color-letras-primary">Bs. ${precioTotalItem}</h2>
                  </div>
                </div>
              </div>
            </div>
          `;

          contenidoIzquierdoHTML += `
              <div class="pcph-itemc_cantidad-grupo">
                <cantidad-input>
                  <div
                    origen-trabajo="carrito"
                    min="1"
                    max="${dataContruccion.item_base.stockTotal}"
                    id="producto-id"
                    handle="producto-handle"
                    class="pcph-itemc_cantidad"
                  >
                    <button
                      accion="decrementar"
                      data-peticion="eliminar"
                      class="pcph-itemc_cantidad-btn elemento-oculto icon-color-tertiary"
                    >
                    ${window.shopIcons.icon_basura}
                    </button>
                    <button
                      accion="decrementar"
                      data-peticion="decrementar"
                      class="pcph-itemc_cantidad-btn  elemento-oculto icon-color-tertiary"
                    >
                     ${window.shopIcons.icon_menos}
                    </button>
                    <p id="phpp-cantidad-general">${dataContruccion.item_base.cantidad}</p>
                    <button
                      accion="incrementar"
                      class="pcph-itemc_cantidad-btn icon-color-tertiary"
                    >
                      ${window.shopIcons.icon_mas}  
                    </button>
                  </div>
                </cantidad-input>
                <div class="pcph-itemc_editar">${window.shopIcons.icon_editar}<p class="color-letras-primary">Editar</p></div>
                <div class="pcph-itemc_eliminar">${window.shopIcons.icon_basura}<p class="color-letras-primary">Eliminar</p></div>
              </div>
          </div>
          `;
        });
      }


      this.contenedorItemsDetalle.innerHTML = contenidoIzquierdoHTML;
      this.etiquetaEnvioADomicilio.textContent = this.estadoTrabajoPagina == "local" ? "Bs. 0" : `Bs. ${this.costoEnvioDomicilio}`;
      this.etiquetaSubtotal.textContent = `Bs. ${precioTotalComparacion}`;
      this.etiquetaDescuento.textContent = `Bs. ${precioTotalComparacion - precioTotal}`;
      this.etiquetaTotal.textContent = `Bs. ${this.estadoTrabajoPagina == "local"
        ? precioTotal
        : precioTotal + this.costoEnvioDomicilio}`;

      this.declararComponentesDespuesCreacion();

      MensajeCargaDatos.ocultar();
    } catch (error) {
      console.error('Hubo un error:', error);
      MensajeCargaDatos.ocultar();
    }
  }

  declararComponentesDespuesCreacion() {
    // DECLARAR ELEMENTOS
    this.btnsEditar = this.querySelectorAll('.pcph-itemc_editar');
    this.btnsEliminar = this.querySelectorAll('.pcph-itemc_eliminar');
    this.btnsEditarCantidadItem = this.querySelectorAll('.pcph-itemc_cantidad-btn');

    // INICIALIZAR EVENTOS
    this.btnsEditar.forEach((btn) => {
      btn.addEventListener('click', this.procedoEditarItem.bind(this, btn));
    });
    this.btnsEliminar.forEach((btn) => {
      btn.addEventListener('click', this.procedoEliminarItem.bind(this, btn));
    });
    this.btnsEditarCantidadItem.forEach((btn) => {
      btn.addEventListener('click', this.actualizarProductoCarrito.bind(this, btn));
    });

    // INICIALIZAR ELEMENTOS Y CARGA DE DATOSS
  }

  async actualizarProductoCarrito(btnElemento) {
    const contenedorPadre = btnElemento.closest('.pcph-item-carrito');
    const dataPeticion = btnElemento.dataset.peticion;
    const keyCarrito = contenedorPadre.dataset.kitem;
    const itemCarrito = this.carrito.items.find(item => item.key === keyCarrito);
    const informacionCompleta = JSON.parse(itemCarrito.properties.estructura);

    // Verificar si el botón es de incrementar o decrementar
    const accionBtn = btnElemento.getAttribute('accion');

    // ============================================================
    // CASO 1: ELIMINAR PRODUCTO COMPLETAMENTE
    // ============================================================
    if (accionBtn == "decrementar" && dataPeticion == "eliminar") {
      MensajeCargaDatos.mostrar('Eliminando producto del carrito...');
      await AuxiliaresGlobal.eliminarItemCarritoPorKey(keyCarrito, 0);
    }
    // ============================================================
    // CASO 2: INCREMENTAR O DECREMENTAR CANTIDAD
    // ============================================================
    else {
      // Obtener la cantidad ACTUAL de la estructura (no del HTML)
      const cantidadActual = parseInt(informacionCompleta.item_base.cantidad);
      let cantidadNueva = cantidadActual;

      // Calcular nueva cantidad según la acción
      if (accionBtn == "incrementar") {
        cantidadNueva = cantidadActual + 1;
      } else if (accionBtn == "decrementar") {
        cantidadNueva = cantidadActual - 1;
        // No permitir cantidades menores a 1
        if (cantidadNueva < 1) {
          cantidadNueva = 1;
        }
      }

      // Actualizar la cantidad del producto base
      informacionCompleta.item_base.cantidad = cantidadNueva;

      // Actualizar las cantidades de las opciones principales (si existen)
      // IMPORTANTE: Se actualiza proporcionalmente según el cambio
      if (informacionCompleta.items_principales.productos.length > 0) {
        informacionCompleta.items_principales.productos.forEach((producto) => {
          const cantidadAnteriorProducto = parseInt(producto.cantidad);
          // Calcular la nueva cantidad proporcionalmente
          producto.cantidad = Math.round((cantidadAnteriorProducto / cantidadActual) * cantidadNueva);
        });
      }

      // Actualizar el carrito en Shopify
      MensajeCargaDatos.mostrar('Actualizando carrito...');
      await AuxiliaresGlobal.actualizarItemCarrito(
        keyCarrito,
        itemCarrito.id,
        cantidadNueva,
        {
          "estructura": JSON.stringify(informacionCompleta)
        }
      );
    }

    // Refrescar el contenido del carrito en la página
    await this.actualizarSoloContenidoCarrito();
    MensajeCargaDatos.ocultar();
  }

  async actualizarSoloContenidoCarrito() {
    try {
      this.carrito = (await AuxiliaresGlobal.obtenerCarritoShopify()).informacionCompleta;

      let contenidoIzquierdoHTML = '';
      let precioTotal = 0;
      let precioTotalComparacion = 0;

      // Si el carrito esta vacio
      if (this.carrito.items.length == 0) {
        this.carritoVacioContenedor.style.display = 'flex';
        this.contenedorItemsDetalle.style.display = 'none';
      } else {
        this.carritoVacioContenedor.style.display = 'none';
        this.contenedorItemsDetalle.style.display = 'flex';

        this.carrito.items.forEach((item) => {

          if (item.properties && item.properties.estructura) {
            const dataContruccion = JSON.parse(item.properties.estructura);

            // Calcular precio individual de este item (no acumulativo)
            let precioTotalItem = dataContruccion.item_base.precio * dataContruccion.item_base.cantidad;
            let precioTotalComparacionItem = dataContruccion.item_base.precio_comparacion == 0
              ? dataContruccion.item_base.precio * dataContruccion.item_base.cantidad
              : dataContruccion.item_base.precio_comparacion * dataContruccion.item_base.cantidad;

            dataContruccion.items_principales.productos.forEach((producto) => {
              precioTotalItem += producto.precio * producto.cantidad;
              precioTotalComparacionItem += producto.precio_comparacion == 0 ? producto.precio * producto.cantidad : producto.precio_comparacion * producto.cantidad;
            });

            // Acumular para el total del carrito
            precioTotal += precioTotalItem;
            precioTotalComparacion += precioTotalComparacionItem;

            contenidoIzquierdoHTML += `
            <div data-kitem="${item.key}" class="pcph-item-carrito">
              <div class="pcph-itemc-detalle">
                <div class="pcph-itemc-imagen">
                  ${precioTotalComparacionItem > precioTotalItem ? `
                    <div class="pcph-itemc-etiqueta-precio-comparacion">
                      <p>${GestorProductos.calcularDescuento(
              precioTotalItem,
              precioTotalComparacionItem
            )}</p>
                    </div>
                    ` : ''}
                  <img src="${dataContruccion.item_base.imagen}" alt="${dataContruccion.item_base.nombre}" width="100" height="100">
                </div>
                <div class="pcph-itemc-info">
                  <div class="pcph-itemc_opcion1">
                    <div class="pcph-itemc_bloque-izq">
                    <div class="pcph-itemc-detalles-primarios">
                      <h1>${dataContruccion.item_base.nombre}</h1>
                      ${dataContruccion.items_principales.productos.length > 0
                ? `<p>${dataContruccion.items_principales.titulo}</p>
                            <ul class="color-letras-extra">`
                : ''
              }
            `;

            let tituloGuardado = "";
            let contenidoGenerado = "";

            dataContruccion.items_principales.productos.forEach((producto, index) => {
              // Preparamos el título del producto, quitando la palabra "Extra" si está presente
              let tituloProducto = producto.nombre;
              if (tituloProducto.includes("Extra")) {
                tituloProducto = tituloProducto.replace("Extra ", "");
              }

              // Si es el primer producto o si cambia el título de sección
              if (index === 0 || tituloGuardado !== producto.titulo) {
                // Si no es el primer producto, cerramos el item anterior
                if (index > 0) {
                  contenidoIzquierdoHTML += contenidoGenerado + "</p></li>";
                }

                // Actualizamos el título guardado
                tituloGuardado = producto.titulo;

                // Iniciamos un nuevo ítem con el título de sección
                contenidoGenerado = `<li><p>${producto.titulo} : <br> ${tituloProducto}`;
              } else {
                // Si es el mismo título de sección, solo agregamos el producto
                contenidoGenerado += `<br> ${tituloProducto}`;
              }
            });

            // No olvidar cerrar el último ítem
            if (dataContruccion.items_principales.productos.length > 0) {
              contenidoIzquierdoHTML += contenidoGenerado + "</p></li>";
            }

            contenidoIzquierdoHTML += `
                      </ul>
                    </div>
                    <div class="pcph-itemc-precio-comparacion pcph-itemc-precio-inline">
                      <h2 class="color-letras-primary">Bs. ${(precioTotalItem / dataContruccion.item_base.cantidad).toFixed(2)}</h2>
                      ${precioTotalComparacionItem > precioTotalItem ? `
                        <h4 class="color-letras-precioCS">Bs. ${(precioTotalComparacionItem / dataContruccion.item_base.cantidad).toFixed(2)}</h4>
                      ` : ''}
                    </div>
                    </div>
                    <div class="pcph-itemc-precio-comparacion pcph-itemc-precio-cantidad">
                      <h2 class="color-letras-primary">Bs. ${precioTotalItem}</h2>
                    </div>
                  </div>
                </div>
              </div>
            `;

            contenidoIzquierdoHTML += `
                <div class="pcph-itemc_cantidad-grupo">
                  <cantidad-input>
                    <div
                      origen-trabajo="carrito"
                      min="1"
                      max="${dataContruccion.item_base.stockTotal}"
                      id="producto-id"
                      handle="producto-handle"
                      class="pcph-itemc_cantidad"
                    >
                      <button
                        accion="decrementar"
                        data-peticion="eliminar"
                        class="pcph-itemc_cantidad-btn elemento-oculto icon-color-tertiary"
                      >
                      ${window.shopIcons.icon_basura}
                      </button>
                      <button
                        accion="decrementar"
                        data-peticion="decrementar"
                        class="pcph-itemc_cantidad-btn  elemento-oculto icon-color-tertiary"
                      >
                       ${window.shopIcons.icon_menos}
                      </button>
                        <p id="phpp-cantidad-general">${dataContruccion.item_base.cantidad}</p>
                      <button
                        accion="incrementar"
                        class="pcph-itemc_cantidad-btn icon-color-tertiary"
                      >
                        ${window.shopIcons.icon_mas}  
                      </button>
                    </div>
                  </cantidad-input>
                  <div class="pcph-itemc_editar">${window.shopIcons.icon_editar}<p class="color-letras-primary">Editar</p></div>
                  <div class="pcph-itemc_eliminar">${window.shopIcons.icon_basura}<p class="color-letras-primary">Eliminar</p></div>
                </div>
            </div>
            `;

          } else {

          };
        });
      }

      this.contenedorItemsDetalle.innerHTML = contenidoIzquierdoHTML;
      this.etiquetaSubtotal.textContent = `Bs. ${precioTotalComparacion}`;
      this.etiquetaEnvioADomicilio.textContent = this.estadoTrabajoPagina == "local" ? "Bs. 0" : `Bs. ${this.costoEnvioDomicilio}`;
      this.etiquetaDescuento.textContent = `Bs. ${precioTotalComparacion - precioTotal}`;
      this.etiquetaTotal.textContent = `Bs. ${this.estadoTrabajoPagina == "local" ? precioTotal : precioTotal + this.costoEnvioDomicilio}`;
      this.declararComponentesDespuesCreacion();
    } catch (error) {
      console.error('Hubo un error:', error);
    }
  }

  async pagarBtnPrincipal() {

    if (!localStorage.getItem('ph-tipo-usuario')) {
      // Validar horario GLOBAL
      if (!GestionSucursales.validarHorarioApertura(window.turnos_apertura_atencion)) {
        console.log("❌ Horario global cerrado");
        ModalInicial.lanzarModalHorarioAtencion();
        return;
      }

      // Validar SUCURSAL ESPECÍFICA seleccionada o primera disponible
      let sucursalAValidar = null;
      if (window.sucursal && window.sucursal.nombre) {
        // Si hay sucursal seleccionada, usar esa
        sucursalAValidar = window.sucursales.find(s => s.nombre === window.sucursal.nombre);
        console.log(`🏪 Validando sucursal seleccionada: ${window.sucursal.nombre}`);
      } else {
        // Si no hay sucursal seleccionada, usar la primera sucursal disponible
        if (window.sucursales && window.sucursales.length > 0) {
          sucursalAValidar = window.sucursales[0];
          console.log(`🏪 No hay sucursal seleccionada, usando primera sucursal: ${sucursalAValidar.nombre}`);
        }
      }

      if (sucursalAValidar) {
        // Primero verificar el estado booleano
        if (!sucursalAValidar.estado) {
          console.log(`❌ La sucursal ${sucursalAValidar.nombre} está cerrada (estado: false)`);
          ModalInicial.lanzarModalHorarioAtencion();
          return;
        }

        // Si el estado es true, validar los turnos específicos de la sucursal
        if (sucursalAValidar.turnos && sucursalAValidar.turnos.length > 0) {
          // Convertir turnos de la sucursal al formato esperado por validarHorarioApertura
          const turnosSucursal = sucursalAValidar.turnos.map(turno => ({
            dias: turno.dias,
            horaInicial: turno.horaInicial,
            horaFinal: turno.horaFinal
          }));
          const sucursalAbiertaPorHorario = GestionSucursales.validarHorarioApertura(turnosSucursal);
          if (!sucursalAbiertaPorHorario) {
            console.log(`❌ La sucursal ${sucursalAValidar.nombre} está cerrada (fuera de horario)`);
            ModalInicial.lanzarModalHorarioAtencion();
            return;
          }
        } else {
          // Si no tiene turnos, considerar cerrada
          console.log(`❌ La sucursal ${sucursalAValidar.nombre} no tiene turnos definidos`);
          ModalInicial.lanzarModalHorarioAtencion();
          return;
        }
      } else {
        console.log("⚠️ No hay sucursales disponibles para validar");
      }
    }

    var cantidadPrecioTotal = 0;

    this.carrito.items.forEach((item) => {
      const detalleProducto = JSON.parse(item.properties.estructura);
      // Producto Base
      cantidadPrecioTotal += parseInt(detalleProducto.item_base.cantidad) * parseInt(detalleProducto.item_base.precio);
      // Opciones Principales
      detalleProducto.items_principales.productos.forEach((producto) => {
        cantidadPrecioTotal += parseInt(producto.cantidad) * parseInt(producto.precio);
      });
    });

    if (cantidadPrecioTotal < window.carritoCantidadMinima) {
      MensajeTemporal.mostrarMensaje(`La cantidad mínima de compra es de ${window.carritoCantidadMinima}Bs. Por favor, agregue más productos.`, 'error', 3500);
      return;
    }

    localStorage.setItem('ph-permiso-checkout', 'true');
    window.location.href = "/pages/checkout-ph";
  }

  procedoEditarItem(btn) {
    const itemBase = btn.closest('.pcph-item-carrito');
    const keyCarrito = itemBase.getAttribute('data-kitem');
    const itemCarrito = this.carrito.items.find(item => item.key === keyCarrito);
    const detalleProducto = JSON.parse(itemCarrito.properties.estructura);
    // -> pizza hut item carrito seleccionado para editar -> phicse
    localStorage.setItem('phicse', JSON.stringify({
      key: keyCarrito,
      ...detalleProducto,
    }));
    const handle = itemCarrito.handle;
    window.location.href = `/products/${handle}?from=cart`;
  }

  async procedoEliminarItem(btn) {
    const itemBase = btn.closest('.pcph-item-carrito');
    const keyCarrito = itemBase.getAttribute('data-kitem');
    MensajeCargaDatos.mostrar('Eliminando producto del carrito...');
    await AuxiliaresGlobal.eliminarItemCarritoPorKey(keyCarrito, 0);
    await this.actualizarSoloContenidoCarrito();
    MensajeCargaDatos.ocultar();
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();

        this.addEventListener(
          'input',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}
